export function LineTerme ({ terme })  {
  return <span className="line__terme">
    <span className="label">{ terme }</span>
  </span>
}

export default LineTerme;